import styled from "styled-components";
import { trueBlue } from "../../utils/StyleHelpers";
import brandLogo from "../../assets/logos/brandLogo.svg";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: ${trueBlue};
  gap: 2rem;
`;

export const StyledFormPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  border-radius: 1rem;
  width: 35rem;
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`;

export const StyledBrandLogo = styled.div`
  width: 37.5rem;
  height: 6.5rem;
  background: url(${brandLogo}) 50% / cover no-repeat;
`;

export const StyledSubContainer = styled.div`
  //width: 32.5rem;
  width: 100%;
  height: 1.1875rem;
`;
